import { Button, Grid } from "@material-ui/core";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { purchase } from "../../../../../api/schema";
import Table from "../../../../../components/Table";
import { openDialog } from "../../../../../modules/ui";
import columns from "./columns";
import Colors from '../../../../../theme/colors';

interface Props {
  purchases: Record<string, any>[];
}

export default ({ purchases }: Props): JSX.Element => {
  const dispatch = useDispatch();
  const handleResubmitButton = useCallback(({ fundingRequest, id }) => {
    dispatch(
      openDialog(
        "resubmit-funding-request",
        "Confirm",
        "Are you sure you want to resubmit this funding request?",
        {
          fundingRequest,
          fundingRequestPurchase: id
        }
      )
    );
  }, []);
  const handleFailedButton = useCallback(({ fundingRequest, id }) => {
    dispatch(
      openDialog(
        "mark-as-failed-funding-request-purchase",
        "Confirm",
        "Are you sure you want to mark this funding request purchase as failed?",
        {
          fundingRequestId: fundingRequest,
          fundingRequestPurchaseId: id,
          status: "failed"
        }
      )
    );
  }, []);
  const purchaseRows = purchases.map(purchase => ({
    ...purchase,
    action:
        purchase?.can_submit_obligation ? (
            <p style={{ color: Colors.danger }}>
                Obligation Payment Failed
            </p>
        ) : ["Returned", "Failed"].includes(purchase.status) ? (
        <Grid>
          <Button
            variant="raised"
            size="medium"
            color="primary"
            onClick={() => handleResubmitButton(purchase)}
          >
            Resubmit
          </Button>
        </Grid>
      ) : ["paid", "misdirected"].includes(purchase.status.toLowerCase()) ? (
        <Grid>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => handleFailedButton(purchase)}
          >
            Mark as Failed
          </Button>
        </Grid>
      ) : (
          <div/>
        )
  }));
  return <Table columns={columns} rows={purchaseRows} allowEmpty />;
};
